import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilledInput, FormControl, FormLabel, FormHelperText } from '@mui/material';
/**
 * A small helper: we'll attach a wheel listener to the *actual* DOM element
 * on focus, removing it on blur. That ensures the wheel events are prevented
 * while the numeric input is focused.
 */
function attachWheelListener(e) {
    // The "wheel" event we want to block
    const wheelHandler = (evt) => {
        evt.preventDefault();
    };
    // We attach it with { passive: false } so we can call evt.preventDefault()
    e.currentTarget.addEventListener('wheel', wheelHandler, { passive: false });
    // Also remove it once the user blurs the input
    const blurHandler = () => {
        e.currentTarget.removeEventListener('wheel', wheelHandler);
        e.currentTarget.removeEventListener('blur', blurHandler);
    };
    e.currentTarget.addEventListener('blur', blurHandler);
}
const HelperTextInput = ({ label, name, value, disabled, onChange, helperText, type, required, minWidth, error, multiline, rows, InputProps, }) => {
    return (_jsxs(FormControl, { fullWidth: true, variant: "filled", sx: { mb: 2, minWidth: { minWidth } }, children: [_jsx(FormLabel, { sx: { color: 'primary.main' }, children: label }), _jsx(FilledInput, { name: name, color: "primary", value: value, onChange: onChange, fullWidth: true, type: type, disabled: disabled, required: required, error: error, multiline: multiline, rows: rows, 
                // If this is a numeric input, attach the focus listener
                onFocus: type === 'number' ? attachWheelListener : undefined, 
                // Spread any additional inputProps
                inputProps: InputProps, sx: {
                    /* Hide spin buttons in Chrome/Firefox */
                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                    },
                    '& input[type=number]': {
                        MozAppearance: 'textfield',
                        appearance: 'textfield',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                    },
                } }), _jsx(FormHelperText, { children: helperText })] }));
};
export default HelperTextInput;
